import React from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser'
import moment from 'moment'

import { isProdEnv } from '../../config/env'

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    autoRefresh: PropTypes.bool,
    children: PropTypes.any.isRequired,
    FallbackComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node]),
  }

  static defaultProps = {
    autoRefresh: false,
    FallbackComponent: null,
  }

  constructor(props) {
    super(props)

    this.state = {
      error: null,
      errorInfo: null,
      eventId: '',
      // eventId: '',
      refreshDate: undefined,
    }
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
      refreshDate: moment().add(30, 'seconds'),
    })

    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key])
      })

      const eventId = Sentry.captureException(error)

      this.setState({
        eventId,
      })

      try {
        localStorage.clear()
      } catch (e) {
        console.error('failed to clear localStorage', e)
      }
    })

    if (isProdEnv && this.props.autoRefresh)
      setTimeout(() => {
        try {
          window.location.href = '/'
        } catch (e) {
          console.log('failed to reload inside error boundary', e)
          Sentry.captureException(e)
        }
      }, 29500)
  }

  render() {
    if (this.state.errorInfo) {
      const Fallback = this.props.FallbackComponent

      if (!Fallback) return null // can be a hidden error catch

      return <Fallback {...this.state} />
    }

    // Normally, just render children
    return this.props.children
  }
}
